import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

Vue.use(VueRouter)

// 解决报错
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => err)
}
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch((err) => err)
}
const config = require('../../config')
var baseUrl = config.$environment //uoqid,webapptest

var array = ['onqid', 'oamid', 'odzid', 'zkzkid']
var areas = window.location.hostname.split('.')[0].indexOf('www') > -1 ? window.location.hostname.split('.')[1] : window.location.hostname.split('.')[0]
if (array.indexOf(areas) > -1) {
  baseUrl = '/'
}
const uniqueKey = new Date().getTime()
const router = new VueRouter({
  mode: 'history',
  base: baseUrl,
  routes: [
    {
      path: '*/',
      name: 'Next',
      component: (resolve) => require(['../template/Next.vue'], resolve),
      props: true,
      meta: { keepAlive: true, scrollTop: 0, title: '共享世界' }
    },
    {
      path: '*/three',
      name: 'ThreePage',
      component: (resolve) => require(['../template/ThreePage.vue'], resolve),
      props: true,
      meta: {
        title: '共享世界'
      }
    },
    // {
    // 	path: '*/flowDetail',
    // 	name: 'flowDetail',
    // 	component: (resolve) => require(['../template/FlowDetail.vue'], resolve),
    // 	meta:{
    // 		title: '共享世界'
    // 	}
    // },
    {
      path: '*/pictureDetail',
      component: (resolve) => require(['../template/PictureDetail.vue'], resolve),
      meta: {
        title: '共享世界'
      }
    },
    {
      path: '*/shopCart',
      component: (resolve) => require(['../template/ShopCartNew.vue'], resolve),
      meta: {
        title: '共享世界'
      }
    },
    {
      path: '*/orderList',
      component: (resolve) => require(['../template/OrderList.vue'], resolve),
      meta: {
        title: '共享世界'
      }
    },
    {
      path: '*/download',
      name: 'download',
      component: (resolve) => require(['../template/DownLoad.vue'], resolve),
      meta: {
        title: '共享世界'
      }
    },
    {
      path: '*/liveMain',
      component: (resolve) => require(['../template/LiveMain.vue'], resolve),
      meta: {
        title: '共享世界'
      }
    },
    {
      path: '*/slideshows',
      name: 'slideShows',
      component: (resolve) => require(['../template/Slideshow.vue'], resolve),
      meta: {
        title: '共享世界'
      }
    },
    {
      path: '*/odzid/:id?',
      name: 'odzid',
      component: (resolve) => require(['../template/SlideshowAllShow.vue'], resolve),
      key: uniqueKey,
      meta: {
        title: '加载中...'
      }
      // component: (resolve) => require(['../template/SlideshowWeChat.vue'], resolve)
      // component: (resolve) => require(['../template/Slideshowcopy.vue'], resolve)
      // component: (resolve) => require(['../template/Slideshow.vue'], resolve)
    },
    {
      path: '*/zkzkid',
      name: 'zkzkid',
      component: (resolve) => require(['../template/OutLink.vue'], resolve),
      meta: {
        title: '共享世界'
      }
    },
    {
      path: '*/onqid',
      name: 'onqid',
      component: (resolve) => require(['../template/OutLink.vue'], resolve),
      meta: {
        title: '共享世界'
      }
    },
    {
      path: '*/oamid',
      name: 'oamid',
      component: (resolve) => require(['../template/OutLink.vue'], resolve),
      meta: {
        title: '共享世界'
      }
    },
    {
      path: '/sso/login',
      name: 'Login',
      component: (resolve) => require(['../template/ssoLogin.vue'], resolve),
      meta: {
        title: '共享世界'
      }
    },
    {
      path: '/newBanner',
      name: 'newBanner',
      component: (resolve) => require(['../components/newBanner.vue'], resolve),
      meta: {
        title: '共享世界'
      }
    },
    {
      path: '*/flowList',
      name: 'flowList',
      component: (resolve) => require(['../template/FlowList.vue'], resolve),
      meta: { keepAlive: true, scrollTop: 0, title: '共享世界' }
    },
    {
      path: '*/weixin',
      name: 'weixin',
      component: (resolve) => require(['../components/weixin.vue'], resolve),
      meta: {
        title: '共享世界'
      }
    },
    {
      path: '*/deliverables',
      name: 'deliverables',
      component: (resolve) => require(['../components/deliverables.vue'], resolve),
      meta: { keepAlive: true, scrollTop: 0, title: '共享世界' }
    },
    {
      path: '*/deliverableDetail',
      name: 'deliverableDetail',
      component: (resolve) => require(['../components/deliverableDetail.vue'], resolve),
      meta: { keepAlive: true, scrollTop: 0, title: '共享世界' }
    },
    {
      path: '*/toQrcode',
      name: 'toQrcode',
      component: (resolve) => require(['../components/toQrcode.vue'], resolve),
      meta: { keepAlive: true, scrollTop: 0, title: '共享世界' }
    },
    // {
    // 	path: '*/ceshi',
    // 	name: 'ceshi',
    // 	component: (resolve) => require(['../components/ceshi.vue'], resolve),
    // 	meta: { keepAlive: true, scrollTop: 0,title: '共享世界' }
    // },
    {
      path: '*/invalidPage',
      name: 'invalidPage',
      component: (resolve) => require(['../components/invalidPage.vue'], resolve),
      meta: { keepAlive: true, scrollTop: 0, title: '共享世界' }
    }
  ]
})

//记录列表页滑动位置
router.beforeEach(async (to, from, next) => {
  // 记录缓存页之前的位置，从详情页返回后可以直接跳转回当前位置
  if (from.meta.keepAlive) {
    // const $content = document.body.scrollTop || document.documentElement.scrollTop
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop
    from.meta.scrollTop = scrollTop || 0
  }
  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (to.name == 'odzid') {
    document.querySelector("link[rel*='icon']").href = '/uoqid/static/utils/logo_deliverables.png'
  } else {
    document.querySelector("link[rel*='icon']").href = '/uoqid/static/utils/head_top_logo.png'
  }
  const response = await Vue.prototype.$http.get('/zciid-deliverable/business/bAppOqmidPage/getDataForOqimd.json?appId=' + Vue.prototype.getQuery('appId'))
  var responseData = response.state
  if (to.name == 'Next' && !responseData) {
    var url = 'https://kh.520ezn.com/oniid/?appId=scjg1'
    if (window.location.hostname.indexOf('kh.520ezn') > -1 && location.href != url) {
      window.location.href = url
    } else {
      router.replace({ name: 'invalidPage' })
    }
  } else if (to.name == 'Next' && array.indexOf(areas) > -1) {
    router.replace({ name: areas })
  } else {
    next()
  }
})
router.afterEach((to, from) => {
  // 控制缩放
  var elm = document.getElementById('app'),
    scale = store.state.Scale
  if (scale) {
    if (window.innerWidth >= 768 && window.innerWidth < 1200 && (to.name == 'Next' || (to.name == 'odzid' && Vue.prototype.getQuery('dataType')))) {
      elm.setAttribute('style', '-webkit-transform:scale(' + scale + ');transform-origin:top left')
      document.querySelector('body').style.cssText = 'overflow-x:hidden'
      if (Vue.prototype.getQuery('promotionTypes')) {
        elm.style.height = window.innerHeight / scale + 'px'
      }
    } else if (Vue.prototype.getQuery('brush')) {
      elm.setAttribute('style', 'width:100%')
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js